import {
    CHANGE_APPLICATION_AND_POLICIES_FIELD, LOGOUT, PAGE_SHIFT, RECEIVE_BAD_RESPONSE_GET_ALL_APPLICATIONS,
    RECEIVE_BAD_RESPONSE_GET_ALL_APPLICATIONS_SUGGESTIONS,
    RECEIVE_DELETE_DRAFTED_APPLICATION_RESPONSE,
    RECEIVE_GET_ALL_APPLICATIONS, RECEIVE_GET_ALL_APPLICATIONS_SUGGESTIONS, RECEIVE_GET_SELECTED_APPLICATION,
    RECEIVE_PATCH_APPLICATION,
    RECEIVE_POST_NEW_APPLICATION, REQUEST_GET_ALL_APPLICATIONS
} from "../actions/index";
import {CLEAR_APPLICATIONS_AND_POLICIES_FILTERS} from "../actions";

const defaultState = {
	receivedApplications: false,
	applications: [],
	closedAndRejected: false,
	selectedView: '20',
	selectedStatus: '',
	suggestions: [],
	selectedSuggestions: [],
	value: '',
	page: 1,
	totalBoxes: 1,
	selectedApplication: {},
	fetching: false,
	badFetchResponse: '',
	includeDraft: false,
	totalRecords: 0,
	caseTypeFilter: '',
	selectedSolicitorFirm: '',
	selectedSolicitorFirms: [],
    selectedSolicitorUsers: [],
	selectedStatuses: [],
	selectedCaseTypes: [],
	selectedSubCaseTypes: [],
	availableSubCaseTypes: [],
	availableCaseTypes: [],
	//flag set to true when the user filters the apps, It is reset when filters are cleared from the ux button
	//when the state of the flag is true => false, then a request to fetch the apps will be fired in the apps and
	// policies hoc in the willReceiveProps lifecycle method
	wasFilterButtonPressed: false
};

export default (state = defaultState, action) => {
	switch (action.type) {
		case CLEAR_APPLICATIONS_AND_POLICIES_FILTERS:
			return {
				...state,
				selectedSolicitorFirms: defaultState.selectedSolicitorFirms,
				selectedSolicitorUsers: defaultState.selectedSolicitorUsers,
				selectedStatuses: defaultState.selectedStatuses,
				selectedCaseTypes: defaultState.selectedCaseTypes,
				selectedSubCaseTypes: defaultState.selectedSubCaseTypes,
				includeDraft: defaultState.includeDraft,
				value: defaultState.value,
				wasFilterButtonPressed: false
			};
		case RECEIVE_DELETE_DRAFTED_APPLICATION_RESPONSE:
			for (let i = 0; i < state.applications.length; i++) {
				if (state.applications[i].id === action.payload.id) {
					let newApplication = [...state.applications];
					newApplication.splice(i,1);
					return {
						...state,
						applications: newApplication
					}
				}
			}
			return {
				...state
			};
		case RECEIVE_POST_NEW_APPLICATION:
			for (let i = 0; i < state.applications.length; i++) {
				if (state.applications[i].id === action.payload.id) {
					let newApplication = [...state.applications];
					if (i !== 0) {
						let swapFirstItem = newApplication[0];
						newApplication[0] = action.payload;
						newApplication[i] = swapFirstItem;
					}
					else {
						newApplication[0] = action.payload;
					}
					return {
						...state,
						applications: newApplication
					}
				}
			}
			return {
				...state,
				applications: [action.payload, ...state.applications]
			};
		case RECEIVE_GET_SELECTED_APPLICATION:
            if(!action.payload) return defaultState;
			return{
				...state,
				selectedApplication: action.payload
			};
		case RECEIVE_PATCH_APPLICATION:
			for (let i = 0; i < state.applications.length; i++) {
				if (state.applications[i].id === action.payload.id) {
					let newApplication = [...state.applications];
					if (i !== 0) {
						let swapFirstItem = newApplication[0];
						newApplication[0] = action.payload;
						newApplication[i] = swapFirstItem;
					}
					else {
						newApplication[0] = action.payload;
					}
					return {
						...state,
						applications: newApplication
					}
				}
			}
			return {
				...state,
				applications: [action.payload, ...state.applications]
			};
		case REQUEST_GET_ALL_APPLICATIONS:
			return {
				...state,
				fetching: true
			};
		case RECEIVE_GET_ALL_APPLICATIONS:
			let totalDisplayBoxes = Math.ceil(action.payload.totalRecords / parseInt(state.selectedView));
			let currentPage = state.page;
			if(state.page > totalDisplayBoxes && totalDisplayBoxes !== 0){
				currentPage = totalDisplayBoxes;
			}
			return {
				...state,
				applications: action.payload.data,
				totalBoxes: totalDisplayBoxes,
				fetching: false,
				receivedApplications: true,
				totalRecords: action.payload.totalRecords,
				page: currentPage
			};
		case RECEIVE_BAD_RESPONSE_GET_ALL_APPLICATIONS:
			return {
				...state,
				fetching: false,
				badFetchResponse: action.payload
			};
		case RECEIVE_GET_ALL_APPLICATIONS_SUGGESTIONS:
			return {
				...state,
				suggestions: action.payload.data
			};
		case RECEIVE_BAD_RESPONSE_GET_ALL_APPLICATIONS_SUGGESTIONS:
			return {
				...state,
				fetching: false,
                badFetchResponse: action.payload
            };
		case CHANGE_APPLICATION_AND_POLICIES_FIELD:
			if (action.payload.key === 'selectedView') {
				let totalDisplayBoxes = Math.ceil(state.applications.length / parseInt(action.payload.value));
				return {
					...state,
					selectedView: action.payload.value,
					totalBoxes: totalDisplayBoxes,
					value: '',
					page: 1
				}
			}
			else if (action.payload.key === 'selectedStatus') {
				return {
					...state,
					selectedStatus: action.payload.value,
					suggestions: [],
					selectedSuggestions: [],
					value: '',
					page: 1
				}
			}
			else if (action.payload.key === 'selectedSuggestions') {
				return {
					...state,
					selectedSuggestions: action.payload.value,
					selectedStatus: '',
					page: 1
				}
			}
			return {
				...state,
				[action.payload.key]: action.payload.value
			};
		case PAGE_SHIFT:
			if (action.payload.direction === 'left' && state.page > 1)
				return {
					...state,
					page: state.page - 1,
					totalBoxes: action.payload.totalPaginationBoxes
				};
			else if (action.payload.direction === 'right' && state.page < state.totalBoxes)
				return {
					...state,
					page: state.page + 1,
					totalBoxes: action.payload.totalPaginationBoxes
				};
			else return {
					...state,
					totalBoxes: action.payload.totalPaginationBoxes
				};
		case LOGOUT:
			return {
				...defaultState
			};
		
		default:
			return state
	}
}